import React from 'react';
import { LogoIcon } from './LogoIcon';
import { LogoText, LogoTagline } from './LogoText';

interface HeroLogoProps {
  size?: number;
  className?: string;
}

export const HeroLogo: React.FC<HeroLogoProps> = ({ size = 58, className = '' }) => {
  const isLarge = size >= 200;
  const textGap = isLarge ? '20px' : '6px';
  const taglineSize = isLarge ? Math.min(24, size * 0.08) : Math.max(11, size * 0.19);
  const titleSize = isLarge ? Math.min(72, size * 0.24) : Math.max(32, size * 0.55);

  return (
    <div
      className={`hero-logo ${className}`}
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: textGap,
        textAlign: 'center',
        maxWidth: '100%',
      }}
    >
      <div
        style={{
          width: '100%',
          maxWidth: size + 'px',
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        <LogoIcon size={isLarge ? size * 0.5 : size * 0.55} />
      </div>

      <div style={{ textAlign: 'center' }}>
        <LogoTagline fontSize={taglineSize} style={{ marginBottom: isLarge ? '8px' : '2px' }} />
        <LogoText fontSize={titleSize} />
      </div>
    </div>
  );
};
